import { useMemo } from 'react';
import { usePointModelContext } from 'application/pages/PointsPage/providers/PointModelProvider';
import { useAccountCompanyDeviceRequests } from 'application/hooks';

import { CompanyDeviceRequestPureType, DeviceTypes, PointShortTypeFragment } from 'domain/api/graphql/generated';

import { DeviceBindStatus, PointDeviceType } from './types';

const preparePoint = (point: PointShortTypeFragment, deviceRequests?: CompanyDeviceRequestPureType[] | null) => {
  let requestedDevice = undefined as CompanyDeviceRequestPureType | undefined;

  (deviceRequests || []).forEach((request) => {
    if (!requestedDevice && request.pointId === point.id) {
      requestedDevice = request;
    }

    if (!(request.pointId === point.id)) {
      return;
    }

    if (new Date(requestedDevice?.lastRequestDate) < new Date(request.lastRequestDate)) {
      requestedDevice = request;
    }
  });

  const deviceType = point.device?.type;
  const bindStatus = point.device && DeviceBindStatus.BINDED;
  const lastRequestTime = point.device?.bindedAt;

  const haveBindedDevice = !!point.device?.bindedAt;
  const deviceRequestedAfter =
    haveBindedDevice && requestedDevice && new Date(requestedDevice.lastRequestDate) > new Date(point.device?.bindedAt);

  const device = {
    ...point.device,
    type: deviceType,
    actualType: deviceType,
    bindStatus,
    lastRequestTime,
  } as PointDeviceType;

  if (requestedDevice && (deviceRequestedAfter || !haveBindedDevice)) {
    device.type = requestedDevice.deviceType as DeviceTypes;
    device.bindStatus = DeviceBindStatus.REQUESTED;
    device.lastRequestTime = requestedDevice.lastRequestDate;

    if (Object.prototype.hasOwnProperty.call(device, 'bindingCode')) {
      // TODO: check TS settings
      // @ts-ignore
      delete device.bindingCode;
    }
  }

  return {
    ...point,
    device: device as PointDeviceType,
  };
};

const usePointPresenter = () => {
  const { points, point } = usePointModelContext();
  const deviceRequests = useAccountCompanyDeviceRequests();

  const pointsWithPlayerStatus = points;

  const pointWithPlayerStatus = useMemo(
    () => point && preparePoint(point as PointShortTypeFragment, deviceRequests),
    [point, deviceRequests]
  );

  return {
    points: pointsWithPlayerStatus,
    point: pointWithPlayerStatus,
  };
};

export default usePointPresenter;
